import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-two-column-embed.scss'

export default register(`section-two-column-embed`, {
    onLoad() {

    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})
